import React from "react";
import { Dumbbell, ShieldCheck, Users, Sparkles, Clock, HeartPulse } from "lucide-react";
import { Reveal } from "./Reveal";

const BENEFITS = [
  { icon: Dumbbell, title: "Modern Equipment", desc: "Latest machines and free weights, well maintained." },
  { icon: Users, title: "Expert Trainers", desc: "Certified coaches who guide you the right way." },
  { icon: Sparkles, title: "Clean & Hygienic", desc: "Spotless floors, fresh air and sanitised gear." },
  { icon: Clock, title: "Flexible Hours", desc: "Open early to late so you train on your time." },
  { icon: HeartPulse, title: "Diet & Wellness", desc: "Simple nutrition tips that actually work." },
  { icon: ShieldCheck, title: "Safe Space", desc: "A friendly crowd where everyone feels welcome." },
];

export const WhyUs = () => {
  return (
    <section data-testid="features-section" className="bg-black py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14">
        <Reveal className="lg:sticky lg:top-28 self-start">
          <span className="text-gold font-semibold uppercase tracking-[0.25em] text-sm">
            Why SVT Golden
          </span>
          <h2 className="font-bebas text-5xl sm:text-6xl text-white mt-3 leading-[0.95]">
            Why People Love Training Here
          </h2>
          <p className="text-zinc-400 mt-5 font-body max-w-md">
            We keep it simple — good gear, good people and real results. Come see the difference
            for yourself with a free trial.
          </p>
          <a
            href="#contact"
            className="inline-block mt-8 bg-gold hover:bg-gold_dark text-black font-bold uppercase tracking-wider px-7 py-3.5 rounded-md transition-all hover:scale-[1.03]"
            data-testid="whyus-cta"
          >
            Get Started
          </a>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-5">
          {BENEFITS.map((b, i) => (
            <Reveal key={b.title} delay={i * 60}>
              <div className="bg-zinc-900 border border-white/10 rounded-xl p-6 h-full hover:border-gold/50 transition-colors">
                <div className="w-12 h-12 rounded-lg bg-gold/10 flex items-center justify-center text-gold mb-4">
                  <b.icon size={24} />
                </div>
                <h3 className="font-bebas text-2xl text-white tracking-wide">{b.title}</h3>
                <p className="text-zinc-400 text-sm mt-1.5 font-body">{b.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
